<app-page-shell variant="default" [embedded]="!!hideClass() || isModal()">
    @if (showForm) {
    <form [formGroup]="viewInfluencerForm" (ngSubmit)="updateInfluencer()" class="needs-validation"
          enctype="multipart/form-data" novalidate>
      <div class="card" [class]="{'no-background' : isModal(), 'shadow-none': isModal()}">
        <div class="card-header py-3" [class.no-background]="isModal()">
          <div class="card-header--title font-size-lg">
            Update Influencer @if (isModal()) {
<i class="fa fa-close float-end cursor-pointer"
                                 (click)="closeModal.emit(true)"></i>
    }
          </div>
        </div>
        <div class="card-body p-0">
          <div class="card card-inline">
            <div class="card-header py-3">
              <div class="card-header--title font-size-lg">
                Influencer's details
              </div>
            </div>
            <div class="card-body p-0">
              <div class="form-wraper">
                <div class="row mb-3">
                  <div class="col-lg-4 col-md-4 col-sm-12 text-center d-flex justify-content-center align-items-start">
                    @if (controls['image']) {
                    <app-sb-input-image
                      formControlName="image"
                      [label]="getImageType()"
                      [autoUpload]="true"
                      [projectId]="projectId()"
                      [showFileBrowser]="false"
                      accept="jpg,jpeg,png,webp"
                      [minWidth]="150"
                      [minHeight]="150"
                      [maxWidth]="2048"
                      [maxHeight]="2048"
                      [maxFileSize]="5242880">
                    </app-sb-input-image>
                    }
                  </div>
                  <div class="col-md-8 col-md-8 col-sm-12">
                    <div class="row">
                      @if (controls['influencer_type_id']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label">
                          <select class="floating-select" formControlName="influencer_type_id"
                                  (change)="createForm($event.target.value);filterSegments()">
                            @for (influencerType of influencerTypes; track influencerType) {
                            <option [value]='influencerType.id'
                                   >{{influencerType.name}}</option>
                            }
                          </select>
                          <span class="highlight"></span>
                          <label>Select Influencer Type :</label>
                        </div>
                      </div>
                      }
                      @if (controls['project_influencer_segment_id']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <app-creatable-select [selectedValue]="f.project_influencer_segment_id.value" #segmentSelect
                                              placeholder="Select a segment" [selectOptions]="segments()"
                                              (optionSelected)="segmentSelected($event)"></app-creatable-select>
                        @if (submitted && f.project_influencer_segment_new_name.errors) {
                        <div class="bar error-brd custom-error"
                            >
                          @if (f.project_influencer_segment_new_name.errors.required) {
                          <div class="invalid-text">
                            Segment is required
                          </div>
                          }
                        </div>
                        }
                        @if (submitted && f.project_influencer_segment_id.errors) {
                        <div class="bar error-brd custom-error"
                            >
                          @if (f.project_influencer_segment_id.errors.required) {
                          <div class="invalid-text">Segment is
                            required
                          </div>
                          }
                        </div>
                        }
                      </div>
                      }

                      @if (controls['name']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label">
                          <input class="floating-input" formControlName="name"
                                 [class.is-invalid]="submitted && f.name.errors"
                                 type="text" placeholder=" ">
                          <span class="highlight"></span>
                          <label>Name
                            <span class="red">*</span>
                          </label>
                          @if (submitted && f.name.errors) {
                          <div class="bar error-brd">
                            @if (f.name.errors.required) {
                            <div class="invalid-text">Name is required</div>
                            }
                          </div>
                          }
                        </div>
                      </div>
                      }
                      @if (controls['prefix']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label">
                          <input class="floating-input" formControlName="prefix"
                                 [class.is-invalid]="submitted && f.prefix.errors"
                                 type="text" placeholder=" ">
                          <span class="highlight"></span>
                          <label>Prefix</label>
                        </div>
                      </div>
                      }

                      @if (controls['first_name']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label">
                          <input class="floating-input" formControlName="first_name"
                                 [class.is-invalid]="submitted && f.first_name.errors"
                                 type="text" placeholder=" ">
                          <span class="highlight"></span>
                          <label>First name
                            <span class="red">*</span>
                          </label>
                          @if (submitted && f.first_name.errors) {
                          <div class="bar error-brd">
                            @if (f.first_name.errors.required) {
                            <div class="invalid-text">First name is required</div>
                            }
                          </div>
                          }
                        </div>
                      </div>
                      }
                      @if (controls['last_name']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label">
                          <input class="floating-input" formControlName="last_name"
                                 [class.is-invalid]="submitted && f.last_name.errors"
                                 type="text" placeholder=" ">
                          <span class="highlight"></span>
                          <label>Last name
                            <span class="red">*</span>
                          </label>
                          @if (submitted && f.last_name.errors) {
                          <div class="bar error-brd">
                            @if (f.last_name.errors.required) {
                            <div class="invalid-text">Last name is required</div>
                            }
                          </div>
                          }
                        </div>
                      </div>
                      }
                      @if (controls['suffix']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label">
                          <input class="floating-input" formControlName="suffix"
                                 [class.is-invalid]="submitted && f.suffix.errors"
                                 type="text" placeholder=" ">
                          <span class="highlight"></span>
                          <label>Suffix</label>
                        </div>
                      </div>
                      }
                      @if (controls['email']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label">
                          <input class="floating-input" formControlName="email"
                                 [class.is-invalid]="submitted && f.email.errors"
                                 type="text" placeholder=" ">
                          <span class="highlight"></span>
                          <label>Email
                            <span class="red">*</span>
                          </label>
                          @if (submitted && f.email.errors) {
                          <div class="bar error-brd">
                            @if (f.email.errors.required) {
                            <div class="invalid-text">Email is required</div>
                            }
                            @if (f.email.errors.email) {
                            <div class="invalid-text">Invalid email address</div>
                            }
                          </div>
                          }
                        </div>
                      </div>
                      }
                      @if (controls['email_alias']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label">
                          <input class="floating-input" formControlName="email_alias"
                                 [class.is-invalid]="submitted && f.email_alias?.errors"
                                 type="text" placeholder=" ">
                          <span class="highlight"></span>
                          <label>Email Alias</label>
                          @if (submitted && f.email_alias?.errors) {
                          <div class="bar error-brd">
                            @if (f.email_alias.errors.email) {
                            <div class="invalid-text">Invalid email address</div>
                            }
                          </div>
                          }
                        </div>
                      </div>
                      }
                      @if (controls['company']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label">
                          <input class="floating-input" formControlName="company"
                                 [class.is-invalid]="submitted && f.company.errors"
                                 type="text" placeholder=" ">
                          <span class="highlight"></span>
                          <label>Company Name</label>
                          @if (submitted && f.company.errors) {
                          <div class="bar error-brd">
                            @if (f.company.errors.required) {
                            <div class="invalid-text">Company is required</div>
                            }
                          </div>
                          }
                        </div>
                      </div>
                      }
                      @if (controls['registration_url']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <app-sb-cta-url-input label="Call To Action Url"
                                              help="This could be your registration link or downloadable form link"
                                              formControlName="registration_url"
                                              [projectId]="projectId() || null"
                                              [utmParams]="callToActionUtmParams()"></app-sb-cta-url-input>
                      </div>
                      }

                      @if (controls['job_title']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label">
                          <input class="floating-input" formControlName="job_title"
                                 [class.is-invalid]="submitted && f.job_title.errors"
                                 type="text" placeholder=" ">
                          <span class="highlight"></span>
                          <label>Job Title</label>
                        </div>
                      </div>
                      }
                      @if (controls['phone']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label">
                          <input class="floating-input" formControlName="phone"
                                 [class.is-invalid]="submitted && f.phone.errors"
                                 type="text" placeholder=" ">
                          <span class="highlight"></span>
                          <label>Phone</label>
                          @if (submitted && f.phone.errors) {
                          <div class="bar error-brd">
                            @if (f.phone.errors) {
                            <div class="invalid-text">Please enter valid phone number.</div>
                            }
                          </div>
                          }
                        </div>
                      </div>
                      }
                      @if (controls['video_url']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label flex-wrap info-input">
                          <input class="floating-input" formControlName="video_url"
                                 [class.is-invalid]="submitted && f.video_url.errors"
                                 type="text" placeholder=" ">
                          <span class="highlight"></span>
                          <label>Video
                          </label>
                          @if (submitted && f.video_url.errors) {
                          <div class="bar error-brd">
                            @if (f.video_url.errors) {
                            <div class="invalid-text">Please enter valid url.</div>
                            }
                          </div>
                          }
                          <app-info-popover
                            info="Insert URL or Embed code">
                          </app-info-popover>
                        </div>
                      </div>
                      }
                      <div class="col-lg-6 col-md-6 col-ms-12" >
                        <div class="floating-label">
                          <app-creatable-select
                            class="floating-input"
                            [selectedValue]="$safeNavigationMigration(selectedSkip?.id)" [valueKey]="'id'" [labelKey]="'title'"
                            [clearable]="true"
                            [hideLabel]="true" [onlyBottomBorder]="false" [isCreatable]="false"
                            [placeholder]="'Select a Skip'" [selectOptions]="skipValues"
                            (optionSelected)="skipSelected($event)"></app-creatable-select>
                          <label>Select Skip Type :</label>
                        </div>
                      </div>
                      @if (influencer?.email_address_validation_status) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label">
                          <div class="floating-input form-control-plaintext d-flex align-items-center" style="min-height: 38px;">
                            @if (influencer.email_address_validation_status === 'valid') {
                            <span class="email-validation-badge email-validation-valid">
                              <i class="fa fa-check-circle me-1"></i>Valid
                            </span>
                            }
                            @if (influencer.email_address_validation_status === 'invalid') {
                            <span class="email-validation-badge email-validation-invalid"
                                  title="This address will be skipped during campaign launches">
                              <i class="fa fa-times-circle me-1"></i>Invalid
                            </span>
                            }
                          </div>
                          <label>Email Validity</label>
                        </div>
                      </div>
                      }
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label flex-wrap info-input">
                          <input class="floating-input" type="text" placeholder="You are receiving this email as a member of our community. This message includes email tracking. Selecting Unsubscribe removes you from this mailing list and disables it." formControlName="email_source_message"
                                 [class.is-invalid]="submitted && f.email_source_message.errors">
                          <span class="highlight"></span>
                          <label>Email Source Message</label>
                          <app-info-popover
                            info="This will be displayed to your audience in the emails they receive. If not set the either the campaign or the project message will be used. Example: You signed up to our newsletter in our previous event">
                          </app-info-popover>
                        </div>
                      </div>
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label flex-wrap info-input">
                          <input class="floating-input" type="text" placeholder="I joined... or I speak at" formControlName="custom_message"
                                 [class.is-invalid]="submitted && f.custom_message.errors">
                          <span class="highlight"></span>
                          <label>Custom Message</label>
                          <app-info-popover
                            info="This will be displayed to your audience in the emails they receive. If not set the either the campaign or the project message will be used. Example: You signed up to our newsletter in our previous event">
                          </app-info-popover>
                        </div>
                      </div>

                      @if (controls['booth_number']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label">
                          <input class="floating-input" type="text" placeholder=" " formControlName="booth_number"
                                 [class.is-invalid]="submitted && f.booth_number.errors">
                          <span class="highlight"></span>
                          <label>Booth#</label>
                        </div>
                      </div>
                      }
                      @if (controls['promo_code']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label">
                          <input class="floating-input" formControlName="promo_code"
                                 [class.is-invalid]="submitted && f.promo_code.errors"
                                 type="text" placeholder=" ">
                          <span class="highlight"></span>
                          <label>Promo Code</label>
                          @if (submitted && f.promo_code.errors) {
                          <div class="bar error-brd">
                            @if (f.promo_code.errors) {
                            <div class="invalid-text">Enter valid promo code</div>
                            }
                          </div>
                          }
                        </div>
                      </div>
                      }
                      @if (controls['badge_image_url']) {
                      <div class="col-lg-6 col-md-6 col-ms-12">
                        <div class="floating-label">
                          <input class="floating-input" formControlName="badge_image_url"
                                 [class.is-invalid]="submitted && f.badge_image_url.errors"
                                 type="text" placeholder=" ">
                          <span class="highlight"></span>
                          <label>Badge Image Url</label>
                          @if (f.badge_image_url?.value) {
                          <img
                               [src]="f.badge_image_url.value"
                               alt="Badge preview"
                               style="max-height: 60px; max-width: 120px; margin-top: 8px;">
                          }
                          @if (submitted && f.badge_image_url.errors) {
                          <div class="bar error-brd">
                            @if (f.badge_image_url.errors) {
                            <div class="invalid-text">Enter valid badge image url</div>
                            }
                          </div>
                          }
                        </div>
                      </div>
                      }
                      @if (controls['sessions']) {
                      <div class="col-md-12">
                        <fieldset class="session-fieldset">
                          <legend style="font-size: 14px; font-weight: 400; color: #5264ae; width: auto; margin-bottom: 0;">Sessions</legend>
                        <div formArrayName="sessions">

                          @for (session of sessionsGroup.controls; track session; let i = $index) {
                          <div
                               [formGroupName]="i"
                               class="session-block">

                            <span class="fieldset-legend">Session {{ i + 1 }}</span>

                            <div class="row">
                              <!-- Title -->
                              <div class="col-md-6 mb-3">
                                <div class="floating-label">
                                  <input class="floating-input" formControlName="title" type="text" placeholder=" ">
                                  <label>Session Title</label>
                                </div>
                              </div>
                              <!-- Description -->
                              <div class="col-md-6 mb-3">
                                <div class="floating-label">
                                  <input class="floating-input" formControlName="description" type="text" placeholder=" ">
                                  <label>Description</label>
                                </div>
                              </div>
                              <!-- Start and End Time: free text before, so a value the field cannot read is kept as it is; new ones are written YYYY-MM-DD hh:mm A. -->
                              <div class="col-md-5 mb-3">
                                <app-sb-input-time type="datetime" label="Start Time" quickPicks="none" valueFormat="YYYY-MM-DD hh:mm A" [keepUnreadable]="true"
                                  formControlName="start_time"></app-sb-input-time>
                              </div>
                              <div class="col-md-5 mb-3">
                                <app-sb-input-time type="datetime" label="End Time" quickPicks="none" valueFormat="YYYY-MM-DD hh:mm A" [keepUnreadable]="true"
                                  formControlName="end_time"></app-sb-input-time>
                              </div>
                              <!-- Add/Remove Buttons -->
                              <div class="col-md-2 d-flex align-items-center justify-content-center mb-3">
                                <!-- Remove -->
                                @if (sessionsGroup.length > 1) {
                                <a (click)="removeSessionButtonClick(i)"
                                   class="cursor-pointer me-3"
                                  >
                                  <i class="fa fa-times-circle plus-btn"></i>
                                </a>
                                }
                                <!-- Add -->
                                @if (sessionsGroup.length - 1 === i) {
                                <a (click)="addSessionButtonClick()"
                                   class="cursor-pointer ms-2"
                                  >
                                  <i class="fa fa-plus-circle plus-btn"></i>
                                </a>
                                }
                              </div>
                            </div>
                          </div>
                          }
                        </div>
                        </fieldset>
                      </div>
                      }
                    </div>
                  </div>
                </div>

                @if (controls['description']) {
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <textarea class="form-control" formControlName="description"
                                placeholder="Description" rows="3"></textarea>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
          </div>

          <!--          SOCIALS-->
          <!--                Social Media Information-->

          <!--                                 placeholder=" "/>-->

          <!--                                 placeholder=" "/>-->


          <!--          TEAMS-->
          <!--                Teams-->
          <!--                                    class="outline-blue-btn upload-btn"-->
          <!--                                    type="button">Upload-->
          <!--                                   #fileInputSocial>-->



          <!--          CUSTOM VARIABLES-->
          <div class="card card-inline">
            <div class="card-header py-3">
              <div class="card-header--title font-size-lg">
                Custom Variables
                <app-info-popover
                  info="Custom variables can be used to easily customize certain aspects of the campaign pages, campaign emails, etc">
                </app-info-popover>
              </div>
            </div>
            <div class="card-body form-padding">
              <div class="form-wraper">
                <div class="row">
                  <div class="col-lg-6 col-md-6 col-ms-12">
                    <div class="floating-label flex-wrap variable-input">
                      <input class="floating-input" formControlName="custom_1"
                             [class.is-invalid]="submitted && f.custom_1.errors"
                             type="text" placeholder=" ">
                      <span class="highlight"></span>
                      <label>Custom 1</label>
                      @if (submitted && f.custom_1.errors) {
                      <div class="bar error-brd">
                        @if (f.custom_1.errors) {
                        <div class="invalid-text">Enter valid value</div>
                        }
                      </div>
                      }
<!--                      <app-variables-->
<!--                      <app-file-browser-->
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-ms-12">
                    <div class="floating-label flex-wrap variable-input">
                      <input class="floating-input" formControlName="custom_2"
                             [class.is-invalid]="submitted && f.custom_2.errors"
                             type="text" placeholder=" ">
                      <span class="highlight"></span>
                      <label>Custom 2</label>
                      @if (submitted && f.custom_2.errors) {
                      <div class="bar error-brd">
                        @if (f.custom_2.errors) {
                        <div class="invalid-text">Enter valid value</div>
                        }
                      </div>
                      }
<!--                      <app-variables-->
<!--                      <app-file-browser-->
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-ms-12">
                    <div class="floating-label flex-wrap variable-input">
                      <input class="floating-input" formControlName="custom_3"
                             [class.is-invalid]="submitted && f.custom_3.errors"
                             type="text" placeholder=" ">
                      <span class="highlight"></span>
                      <label>Custom 3</label>
                      @if (submitted && f.custom_3.errors) {
                      <div class="bar error-brd">
                        @if (f.custom_3.errors) {
                        <div class="invalid-text">Enter valid value</div>
                        }
                      </div>
                      }
<!--                      <app-variables-->
<!--                      <app-file-browser-->
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-ms-12">
                    <div class="floating-label flex-wrap variable-input">
                      <input class="floating-input" formControlName="custom_4"
                             [class.is-invalid]="submitted && f.custom_4.errors"
                             type="text" placeholder=" ">
                      <span class="highlight"></span>
                      <label>Custom 4</label>
                      @if (submitted && f.custom_4.errors) {
                      <div class="bar error-brd">
                        @if (f.custom_4.errors) {
                        <div class="invalid-text">Enter valid value</div>
                        }
                      </div>
                      }
<!--                      <app-variables-->
<!--                      <app-file-browser-->
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-ms-12">
                    <div class="floating-label flex-wrap variable-input">
                      <input class="floating-input" formControlName="custom_5"
                             [class.is-invalid]="submitted && f.custom_5.errors"
                             type="text" placeholder=" ">
                      <span class="highlight"></span>
                      <label>Custom 5</label>
                      @if (submitted && f.custom_5.errors) {
                      <div class="bar error-brd">
                        @if (f.custom_5.errors) {
                        <div class="invalid-text">Enter valid value</div>
                        }
                      </div>
                      }
<!--                      <app-variables-->
<!--                      <app-file-browser-->
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-ms-12">
                    <div class="floating-label flex-wrap variable-input">
                      <input class="floating-input" formControlName="custom_6"
                             [class.is-invalid]="submitted && f.custom_6.errors"
                             type="text" placeholder=" ">
                      <span class="highlight"></span>
                      <label>Custom 6</label>
                      @if (submitted && f.custom_6.errors) {
                      <div class="bar error-brd">
                        @if (f.custom_6.errors) {
                        <div class="invalid-text">Enter valid value</div>
                        }
                      </div>
                      }
<!--                      <app-variables-->
<!--                      <app-file-browser-->
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-ms-12">
                    <div class="floating-label flex-wrap variable-input">
                      <input class="floating-input" formControlName="custom_7"
                             [class.is-invalid]="submitted && f.custom_7.errors"
                             type="text" placeholder=" ">
                      <span class="highlight"></span>
                      <label>Custom 7</label>
                      @if (submitted && f.custom_7.errors) {
                      <div class="bar error-brd">
                        @if (f.custom_7.errors) {
                        <div class="invalid-text">Enter valid value</div>
                        }
                      </div>
                      }
<!--                      <app-variables-->
<!--                      <app-file-browser-->
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-ms-12">
                    <div class="floating-label flex-wrap variable-input">
                      <input class="floating-input" formControlName="custom_8"
                             [class.is-invalid]="submitted && f.custom_8.errors"
                             type="text" placeholder=" ">
                      <span class="highlight"></span>
                      <label>Custom 8</label>
                      @if (submitted && f.custom_8.errors) {
                      <div class="bar error-brd">
                        @if (f.custom_8.errors) {
                        <div class="invalid-text">Enter valid value</div>
                        }
                      </div>
                      }
<!--                      <app-variables-->
<!--                      <app-file-browser-->
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-ms-12">
                    <div class="floating-label flex-wrap variable-input">
                      <input class="floating-input" formControlName="custom_9"
                             [class.is-invalid]="submitted && f.custom_9.errors"
                             type="text" placeholder=" ">
                      <span class="highlight"></span>
                      <label>Custom 9</label>
                      @if (submitted && f.custom_9.errors) {
                      <div class="bar error-brd">
                        @if (f.custom_9.errors) {
                        <div class="invalid-text">Enter valid value</div>
                        }
                      </div>
                      }
<!--                      <app-variables-->
<!--                      <app-file-browser-->
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-ms-12">
                    <div class="floating-label flex-wrap variable-input">
                      <input class="floating-input" formControlName="custom_10"
                             [class.is-invalid]="submitted && f.custom_10.errors"
                             type="text" placeholder=" ">
                      <span class="highlight"></span>
                      <label>Custom 10</label>
                      @if (submitted && f.custom_10.errors) {
                      <div class="bar error-brd">
                        @if (f.custom_10.errors) {
                        <div class="invalid-text">Enter valid value</div>
                        }
                      </div>
                      }
<!--                      <app-variables-->
<!--                      <app-file-browser-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div _ngcontent-c4="" class="text-end mt-3 mb-3">
            <button _ngcontent-c4="" class="blue-btn me-2" type="submit">
              Save
            </button>
          </div>
        </div>
      </div>
    </form>
}
</app-page-shell>
